import { createContext, useContext } from "react";
import { apiService, type ApiService } from "../services/apiService";

const ApiServiceContext = createContext<ApiService>(apiService);

export const ApiServiceProvider = ApiServiceContext.Provider;

export function useApiService(): ApiService {
  return useContext(ApiServiceContext);
}
